import { EVENT_CONFIG, isInDateRange } from '@/config/events';

export default function isPremium() {
  return (
    this.$store.state.userData && this.$store.state.userData.premium_version ||
    isInDateRange(EVENT_CONFIG.ild.premiumStart(), EVENT_CONFIG.ild.premiumEnd())
  );
}
